import type { GameDescriptor } from '@everyturn/engine/runtime';

export const sortSpreadTestDescriptor = {
  gameId: 'sort-spread-test',
  displayName: 'Sortable Spread Test',
  seats: ['south'],
  minPlayers: 1,
  maxPlayers: 1,
  defaultSeat: 'south',
} as const satisfies GameDescriptor;
